import { format, isToday, isTomorrow, isValid } from 'date-fns';
import { TZDate } from '@date-fns/tz';

type GetTourDateTime = {
  startMs: string;
  timeZone: string;
  capitalizeText?: boolean;
};

export default function getTourDateTime({ startMs = '', timeZone, capitalizeText = true }: GetTourDateTime): string {
  // Return early if startMs is empty or whitespace
  if (!startMs || !startMs.trim()) {
    return '';
  }

  // Convert startMs to a number and create a Date object
  const timestamp = +startMs;
  const date = new Date(timestamp);

  // Validate the date is valid and timestamp is a valid number
  if (!isValid(date) || isNaN(timestamp) || timestamp <= 0) {
    return '';
  }

  try {
    // Convert to the target timezone for all date operations.
    const tzDate = new TZDate(date, timeZone);

    const formatTime = (tzDate: TZDate) => {
      const minutes = tzDate.getMinutes();
      return minutes === 0 ? format(tzDate, 'haaa') : format(tzDate, 'h:mmaaa');
    };

    const formattedTime = formatTime(tzDate);
    const formattedDate = format(tzDate, "E, MMM d 'at'");

    if (isToday(tzDate)) {
      return capitalizeText ? `Today at ${formattedTime}` : `today at ${formattedTime}`;
    }

    if (isTomorrow(tzDate)) {
      return capitalizeText ? `Tomorrow at ${formattedTime}` : `tomorrow at ${formattedTime}`;
    }

    return `${formattedDate} ${formattedTime}`;
  } catch {
    // TZDate failed. Return empty so the UI can show a fallback or "Time unavailable"
    return '';
  }
}
